import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Heading,
  VStack,
  Card,
  CardBody,
  Image,
  Text,
  useInterval,
  HStack,
  IconButton,
  Circle,
  Flex,
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const winners = [
  {
    year: 2025,
    image: "/data/past_winners/2025.jpeg",
    name: "Winner 2025",
  },
  {
    year: 2024,
    image: "/data/past_winners/2024.jpeg",
    name: "Winner 2024",
  },
  {
    year: 2023,
    image: "/data/past_winners/2023.jpeg",
    name: "Winner 2023",
  },
  {
    year: 2022,
    image: "/data/past_winners/2022.jpeg",
    name: "Winner 2022",
  },
  {
    year: 2021,
    image: "/data/past_winners/2021.jpeg",
    name: "Winner 2021",
  },
  {
    year: 2020,
    image: "/data/past_winners/2020.jpeg",
    name: "Winner 2020",
  },
  {
    year: 2019,
    image: "/data/past_winners/2019.jpeg",
    name: "Winner 2019",
  },
  {
    year: 2018,
    image: "/data/past_winners/2018.jpeg",
    name: "Winner 2018",
  },
  {
    year: 2017,
    image: "/data/past_winners/2017.jpeg",
    name: "Winner 2017",
  },
  {
    year: 2016,
    image: "/data/past_winners/2016.jpeg",
    name: "Winner 2016",
  },
  {
    year: 2015,
    image: "/data/past_winners/2015.jpeg",
    name: "Winner 2015",
  },
  {
    year: 2014,
    image: "/data/past_winners/2014_v2.jpeg",
    name: "Winner 2014",
  },
  {
    year: 2013,
    image: "/data/past_winners/2013.jpeg",
    name: "Winner 2013",
  },
];

const PastWinner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);

  // Auto scroll every 5 seconds if enabled
  useInterval(
    () => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % winners.length);
    },
    isAutoScrolling ? 5000 : null
  );

  const nextIndex = (currentIndex + 1) % winners.length;

  const handlePrevious = () => {
    setIsAutoScrolling(false);
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? winners.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setIsAutoScrolling(false);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % winners.length);
  };

  const handleDotClick = (index) => {
    setIsAutoScrolling(false);
    setCurrentIndex(index);
  };

  return (
    <Container maxW="container.lg" py={8}>
      <VStack spacing={8}>
        <Heading size="lg" textAlign="center">
          Past Tournament Winners
        </Heading>

        <Box
          w="full"
          maxW="900px"
          mx="auto"
          position="relative"
          overflow="visible"
        >
          {/* Navigation Buttons */}
          <IconButton
            icon={<ChevronLeftIcon boxSize={8} />}
            aria-label="Previous winner"
            position="absolute"
            left="-20px"
            top="50%"
            transform="translateY(-50%)"
            zIndex={3}
            rounded="full"
            bg="green.700"
            color="white"
            _hover={{ bg: "green.600" }}
            onClick={handlePrevious}
            boxShadow="lg"
          />
          <IconButton
            icon={<ChevronRightIcon boxSize={8} />}
            aria-label="Next winner"
            position="absolute"
            right="-20px"
            top="50%"
            transform="translateY(-50%)"
            zIndex={3}
            rounded="full"
            bg="green.700"
            color="white"
            _hover={{ bg: "green.600" }}
            onClick={handleNext}
            boxShadow="lg"
          />

          <Box position="relative" width="100%">
            {/* Current Card */}
            <Card
              bg="green.700"
              color="white"
              transition="transform 0.5s ease-in-out"
              w="full"
              zIndex={2}
              boxShadow="2xl"
              position="relative"
            >
              <CardBody>
                <VStack spacing={4}>
                  <Image
                    src={winners[currentIndex].image}
                    alt={`Winner ${winners[currentIndex].year}`}
                    borderRadius="lg"
                    objectFit="cover"
                    w="full"
                    h="500px"
                  />
                  <Heading size="md">{winners[currentIndex].name}</Heading>
                  <Text fontSize="xl" fontWeight="bold">
                    {winners[currentIndex].year} Champion
                  </Text>
                </VStack>
              </CardBody>
            </Card>

            {/* Peek of Next Card */}
            <Card
              bg="green.600"
              color="white"
              w="full"
              position="absolute"
              top={0}
              left="40px"
              zIndex={1}
              opacity={0.7}
              transform="scale(0.98)"
              boxShadow="xl"
            >
              <CardBody>
                <VStack spacing={4}>
                  <Image
                    src={winners[nextIndex].image}
                    alt={`Winner ${winners[nextIndex].year}`}
                    borderRadius="lg"
                    objectFit="cover"
                    w="full"
                    h="400px"
                  />
                  <Heading size="md">{winners[nextIndex].name}</Heading>
                  <Text fontSize="xl" fontWeight="bold">
                    {winners[nextIndex].year} Champion
                  </Text>
                </VStack>
              </CardBody>
            </Card>
          </Box>

          {/* Dot Indicators */}
          <Flex justify="center" mt={6}>
            {winners.map((_, index) => (
              <Circle
                key={index}
                size="10px"
                bg={currentIndex === index ? "green.500" : "green.800"}
                mx={1}
                cursor="pointer"
                onClick={() => handleDotClick(index)}
                transition="background-color 0.3s"
                _hover={{ bg: "green.600" }}
              />
            ))}
          </Flex>
        </Box>
      </VStack>
    </Container>
  );
};

export default PastWinner;
